import cookieRegistry from "./cookies.json";

export type CookieConfig = Record<
  string,
  { category: "essential" | "performance" | "functional" | "advertising" }
>;

export function getCookieConfig(
  additionalCookies?: CookieConfig
): CookieConfig {
  return {
    ...(cookieRegistry as CookieConfig),
    ...additionalCookies,
  };
}
